/* Packages */
import React from 'react';

export default function Icon({url, size = 24, classes = ''}) {
	/* Render */
	return (
		<svg className={`icon icon--${size} ${classes}`.trim()}>
			<use xlinkHref={url}></use>
		</svg>
	);
}
